import { render, staticRenderFns } from "./ItemFilterHoldingLayout.vue?vue&type=template&id=46f6f784&scoped=true&"
import script from "./ItemFilterHoldingLayout.vue?vue&type=script&lang=js&"
export * from "./ItemFilterHoldingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6f784",
  null
  
)

export default component.exports